<template>
  <div class="resume">
    <!-- @click-left="onClickLeft"-->
    <van-nav-bar title="我的简历"
                 :right-text="showAll"
                 @click-right="onClickRight" />

    <van-collapse v-model="activeNames">
      <van-collapse-item name="1"
                         :border="false"
                         class="basic">
        <template #title>
          <div class="home">
            <p class="bold">基本信息</p>
            <p @click.stop="gotoContactInfo">
              <van-icon name="edit" />编辑
            </p>
          </div>
        </template>
        <div>
          工号：<span>{{ basic.EMPLID }}</span>
        </div>
        <div>
          姓名：<span>{{ basic.NAME }}</span>
        </div>
        <div>
          部门：<span>{{ basic.DEPT_DESCR }}</span>
        </div>
        <div>
          职位：<span>{{ basic.POSN_DESCR }}</span>
        </div>
        <div>
          性别：<span>{{ basic.SEX }}</span>
        </div>
        <div>
          出生日期：<span>{{ basic.BIRTHDATE }}</span>
        </div>
        <div>
          籍贯：<span>{{ basic.HOMETOWN }}</span>
        </div>
        <div>
          政治面貌：<span>{{ basic.POLITICAL }}</span>
        </div>
        <div>
          民族：<span>{{ basic.ETHNIC_DESCR }}</span>
        </div>
        <div>
          婚姻状况：<span>{{ basic.MAR_STATUS }}</span>
        </div>
        <p>
          毕业院校：<span>{{ basic.C_EDCT_SCHL }}</span>
        </p>
        <div>
          专业：<span>{{ basic.C_EDCT_PRFN }}</span>
        </div>
        <div>
          最高学历：<span>{{ basic.C_EDCT_BAKG }}</span>
        </div>
        <p>
          学历形式：<span>{{ basic.C_EDCT_LRNG_STYLE }}</span>
        </p>
        <div>
          入集团时间：<span>{{ basic.C_JOINGROUP_DT }}</span>
        </div>
        <div>
          入党日期：<span>{{ basic.C_JOIN_PARTY_DT }}</span>
        </div>
        <p>
          个人邮箱：<span>{{ basic.C_EMAIL_PERS }}</span>
        </p>
        <div>
          联系电话：<span>{{ basic.MOBILE_PHONE }}</span>
        </div>
        <div>
          短号：<span>{{ basic.C_MOBILE_SHORT_NUMBER }}</span>
        </div>
        <p>
          身份证号：<span>{{ basic.NATIONAL_ID }}</span>
        </p>

        <p>
          家庭地址：<span>{{ basic.C_ADDRESS_CE }}</span>
        </p>
        <p>
          现居住地址：<span>{{ basic.C_ADDRESS_CUR }}</span>
        </p>

        <p class="relation-box"></p>
        <p>
          紧急联系人：<span>{{ basic.C_RELATED_NAME }}</span>
        </p>
        <p>
          紧急联系人关系：<span>{{ basic.C_RELATIONGSHIP }}</span>
        </p>
        <p>
          紧急联系电话：<span>{{ basic.C_RELATED_PHONE }}</span>
        </p>
      </van-collapse-item>
      <van-collapse-item :border="false"
                         title="公司现任职务"
                         name="2">
        <div class="edumessage">
          <van-row class="message-bg">
            <div class="message-bg1"></div>
            <van-col span="4">
              <p>生效日期</p>
            </van-col>
            <van-col span="5">
              <p>公司</p>
            </van-col>
            <van-col span="4">
              <p>部门</p>
            </van-col>
            <van-col span="4">
              <p>职位</p>
            </van-col>
            <van-col span="3">
              <p>职级</p>
            </van-col>
            <van-col span="4">
              <p>岗位类型</p>
            </van-col>
          </van-row>
          <van-row class="edumessage-bt"
                   v-for="(item, index) in nowWork"
                   :key="index">
            <van-col span="4">{{ item.EFFDT }}</van-col>
            <van-col span="5">{{ item.COMPANY_DESCR }}</van-col>
            <van-col span="4">{{ item.DEPT_DESCR }}</van-col>
            <van-col span="4">{{ item.POSITION_DESCR }}</van-col>
            <van-col span="3">{{ item.POSN_GRDE_DESCR }}</van-col>
            <van-col span="4">{{ item.EMPL_RCD }}</van-col>
          </van-row>
        </div>
      </van-collapse-item>
      <van-collapse-item :border="false"
                         title="集团历任职务"
                         name="3">
        <div class="edumessage">
          <van-row class="message-bg">
            <div class="message-bg1"></div>
            <van-col span="5">
              <p>开始日期</p>
            </van-col>
            <van-col span="5">
              <p>结束日期</p>
            </van-col>
            <van-col span="5">
              <p>公司</p>
            </van-col>
            <van-col span="5">
              <p>部门</p>
            </van-col>
            <van-col span="4">
              <p>职位</p>
            </van-col>
          </van-row>
          <van-row class="edumessage-bt"
                   v-for="(item, index) in historyWork"
                   :key="index">
            <van-col span="5">{{ item.C_START_DT }}</van-col>
            <van-col span="5">{{ item.C_END_DT }}</van-col>
            <van-col span="5">{{ item.COMPANY_DESCR }}</van-col>
            <van-col span="5">{{ item.DEPT_DESCR }}</van-col>
            <van-col span="4">{{ item.POSITION_DESCR }}</van-col>
          </van-row>
        </div>
      </van-collapse-item>

      <van-collapse-item :border="false"
                         title="社会工作经历"
                         name="4"
                         class="workexp">
        <section v-for="(item, index) in preEmpl"
                 :key="index">
          <div class="jobdata-top">
            <span class="jobdata-crile"><img src="../assets/cricle@2x.png"
                   alt="" /></span>
            <span>{{ item.C_START_DATE }} - {{ item.C_END_DATE }}</span>
          </div>
          <div class="work-bt">
            <p>
              <span>工作单位：{{ item.C_PRE_COMPANY }}</span>
            </p>
            <p>
              <span>工作职务：{{ item.C_PRE_POSITION }}</span>
            </p>
            <div>
              离职原因：
              <div class="workexp-title">
                {{ item.DESCRLONG }}
              </div>
            </div>

          </div>
        </section>
      </van-collapse-item>
      <van-collapse-item :border="false"
                         title="教育信息"
                         name="5">
        <section class="jobdata"
                 style="margin-bottom: 0"
                 v-for="(item, index) in edctBakg"
                 :key="index">
          <div class="jobdata-top">
            <span class="jobdata-crile"><img src="../assets/cricle@2x.png"
                   alt="" /></span>
            <span>{{ item.C_EDCT_IN_DT }}- {{ item.C_EDCT_OUT_DT }}</span>
          </div>
          <div class="jobdata-bt">
            <div class="jobdata-flex">
              <p style="overflow: hidden;height:22px;">
                <img src="../assets/school(3)@2x.png"
                     alt="" />{{
                  item.C_EDCT_SCHL
                }}
              </p>
              <div>
                <img src="../assets/school(2)@2x.png"
                     alt="" />{{
                  item.C_EDCT_BAKG
                }}
              </div>
            </div>
            <div class="jobdata-flex">
              <p>
                <img src="../assets/text@2x.png"
                     alt="" />{{ item.C_EDCT_PRFN }}
              </p>
              <div>
                <img src="../assets/book@2x.png"
                     alt="" />{{
                  item.C_EDCT_DEGE
                }}
              </div>
            </div>
          </div>
        </section>
      </van-collapse-item>

      <van-collapse-item :border="false"
                         title="证书信息"
                         name="6">
        <div class="edumessage">
          <van-row class="message-bg">
            <div class="message-bg1"></div>
            <van-col span="6">
              <p>获证日期</p>
            </van-col>
            <van-col span="6">
              <p>到期日期</p>
            </van-col>
            <van-col span="6">
              <p>证书名称</p>
            </van-col>
            <van-col span="6">
              <p>证书等级</p>
            </van-col>
          </van-row>
          <van-row class="edumessage-bt"
                   v-for="(item, index) in certificate"
                   :key="index">
            <van-col span="6">{{ item.C_CTFCT_DT }}</van-col>
            <van-col span="6">{{ item.C_CTFCT_MTRT_DT }}</van-col>
            <van-col span="6">{{ item.C_CTFCT_NAME }}</van-col>
            <van-col span="6">{{ item.C_CTFCT_CLASS }}</van-col>

          </van-row>
        </div>
      </van-collapse-item>

      <van-collapse-item :border="false"
                         title="职称信息"
                         name="7">
        <div class="edumessage">
          <van-row class="message-bg">
            <div class="message-bg1"></div>
            <van-col span="5">
              <p>获证日期</p>
            </van-col>
            <van-col span="5">
              <p>到期日期</p>
            </van-col>
            <van-col span="5">
              <p>职称类型</p>
            </van-col>
            <van-col span="5">
              <p>职称名称</p>
            </van-col>
            <van-col span="4">
              <p>职称等级</p>
            </van-col>

          </van-row>
          <van-row class="edumessage-bt"
                   v-for="(item, index) in jobTitle"
                   :key="index">
            <van-col span="5">{{ item.START_DT }}</van-col>
            <van-col span="5">{{ item.END_DT }}</van-col>
            <van-col span="5">{{ item.C_TITLE_TYPE }}</van-col>
            <van-col span="5">{{ item.C_TITLE_NM }}</van-col>
            <van-col span="4">{{ item.C_TITLE_LEVEL }}</van-col>

          </van-row>
        </div>
      </van-collapse-item>
      <van-collapse-item :border="false"
                         title="培训信息"
                         name="8">
        <section class="jobdata"
                 v-for="(item, index) in training"
                 :key="index">
          <div class="jobdata-top">
            <span class="jobdata-crile"><img src="../assets/cricle@2x.png"
                   alt="" /></span>
            <span>{{ item.C_START_DATE }} - {{ item.C_END_DATE }}</span>
          </div>
          <div class="jobdata-bt">
            <div>
              <p style="margin-right: 10px">{{ item.C_TRN_CLS_NM }}</p>
              <p>{{ item.C_TRN_NM }}</p>
              <span class="jobdata-i">{{ item.C_TRN_SCORE }}</span>

            </div>
            <p>
              {{ item.COMPANY_TBL_DESCR }}

            </p>
          </div>
        </section>
      </van-collapse-item>

      <van-collapse-item :border="false"
                         title="奖励信息"
                         name="9">
        <div class="edumessage">
          <van-row class="message-bg">
            <div class="message-bg1"></div>
            <van-col span="6">
              <p>奖励日期</p>
            </van-col>
            <van-col span="6">
              <p>奖励类型</p>
            </van-col>
            <van-col span="6">
              <p>奖励类别</p>
            </van-col>
            <van-col span="6">
              <p>奖励名称</p>
            </van-col>

          </van-row>
          <van-row class="edumessage-bt"
                   v-for="(item, index) in rwdInfo"
                   :key="index">
            <van-col span="6">{{ item.C_RWD_DATE }}</van-col>
            <van-col span="6">{{ item.C_REWARD_TYPE }}</van-col>
            <van-col span="6">{{ item.C_REWARD_CATEGORY }}</van-col>
            <van-col span="6">{{ item.C_REWARD_NM }}</van-col>
          </van-row>
        </div>
      </van-collapse-item>

      <van-collapse-item :border="false"
                         title="处分信息"
                         name="10">
        <!-- v-if="punished.length==0?false:true" -->
        <section class="message"
                 v-for="(item, index) in punished"
                 :key="index"
                 style="border-bottom:1px dashed #ccc;margin-bottom:10px;">
          <p>
            处分日期：<span>{{ item.C_PNS_DATE }}</span>
          </p>
          <p>
            处分级别：<span>{{ item.C_PNS_LVL }}</span>
          </p>
          <p>
            处分种类：<span>{{ item.C_PNS_CATEGORY }}</span>
          </p>

          <p>
            处置形式：<span>{{ item.C_PSN_FORM }}</span>
          </p>

          <p>
            解除原因：<span>{{ item.C_PNS_REASON }}</span>
          </p>
        </section>
      </van-collapse-item>
      <van-collapse-item :border="false"
                         title="绩效信息"
                         name="11">

        <div class="edumessage">
          <van-row class="message-bg">
            <div class="message-bg1"></div>
            <van-col span="6">
              <p>绩效周期</p>
            </van-col>
            <van-col span="6">
              <p>年份</p>
            </van-col>
            <van-col span="6">
              <p>绩效等级</p>
            </van-col>
            <van-col span="6">
              <p>备注</p>
            </van-col>
          </van-row>
          <van-row class="edumessage-bt"
                   v-for="(item, index) in assessInfo"
                   :key="index">
            <van-col span="6">{{ item.C_ASSESSMENT_CYCLE }}</van-col>
            <van-col span="6">{{ item.CAL_PRD_ID }}</van-col>
            <van-col span="6">{{ item.C_PERF_LEVEL }}</van-col>
            <van-col span="6">{{ item.COMMENTS }}</van-col>
          </van-row>
        </div>
      </van-collapse-item>

      <div class="blank">

      </div>
    </van-collapse>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { GetResumeDataApi, deleteMsgDataApi } from '../request/api'
import axios from 'axios'
export default {
  name: 'resume',
  data() {
    return {
      activeNames: ['1'],
      showAll: '全部展开',
      basic: [], //基本信息
      edctBakg: [], //教育背景
      nowWork: [], //现任任职记录
      historyWork: [], //历史任职记录
      preEmpl: [], //以往工作经历
      certificate: [], //证书信息
      jobTitle: [], //职称信息
      training: [], //培训信息
      rwdInfo: [], //奖励信息
      punished: [], //处分信息
      assessInfo: [], //绩效信息

      showData1: false,
      showData2: false,
      position: '',
      show: false,
      num: 0,
    }
  },
  methods: {
    // deleteMsg() {
    //   let params = {
    //     security: {
    //       signTxt: 'OTQ5QKE3NJJFNDQ0Q0JFM0JDNURDNJM2MTG4NKIWQJM3=',
    //       ipAddress: '10.19.185.14',
    //       system: 'SELF',
    //       pubkeyRmk: 'Z7PCKFDMBPVHGS0ZGDQT ',
    //     },
    //     parameters: {
    //       EMPLID: sessionStorage.getItem('EMPLID'),
    //       C_SEQUENCE_NUM: this.num,
    //     },
    //   }

    //   deleteMsgDataApi(params).then((res) => {
    //     if (res.CODE == 1) {
    //       Toast.success('提交成功')
    //       this.getData()
    //       this.show = false
    //     } else {
    //       Toast.fail('提交失败' + res.MESSAGE)
    //     }
    //   })
    // },
    cancel() {
      this.show = false
    },
    showPopup(val) {
      this.show = true
      this.num = val
    },
    // gotoHomeMsg(item) {
    //   this.$router.push({ path: 'homemsg', query: item })
    // },
    /**
     * 个人简历信息编辑
     *  **/
    gotoContactInfo() {
      let paramData = this.basic

      this.$router.push({ path: 'contactinfo', query: { paramData } })
    },

    onClickRight() {
      if (this.showAll == '全部收起') {
        this.activeNames = []
        this.showAll = '全部展开'
      } else {
        this.activeNames.push(
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '10',
          '11'
        )
        this.showAll = '全部收起'
      }
    },

    /**
     * 获取个人简历信息
     *  **/
    getData() {
      let params = {
        EMPLID: sessionStorage.getItem('EMPLID'),
        EMPL_RCD: 0,
      }
      GetResumeDataApi(params).then((res) => {
        if (res.CODE == 200) {
          let dataList =
            typeof res.DATA == 'string' ? JSON.parse(res.DATA) : res.DATA
          let {
            BASIC,
            EDUCATION,
            POSNRRECORD,
            POSNHISTORY,
            PREWORK,
            CTFCT,
            TITLE,
            TRAINING,
            REWARD,
            PUNISH,
            ASSESS,
          } = dataList
          this.basic = BASIC
          this.edctBakg = EDUCATION
          this.nowWork = POSNRRECORD
          this.historyWork = POSNHISTORY
          this.preEmpl = PREWORK
          this.certificate = CTFCT
          this.jobTitle = TITLE
          this.training = TRAINING
          this.rwdInfo = REWARD
          this.punished = PUNISH
          this.assessInfo = ASSESS
        }
      })
    },
  },
  created() {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-nav-bar__left i {
  color: black;
  font-size: 20px;
}
/deep/ .van-collapse-item__content {
  padding-top: 0px;
}
/deep/ .van-nav-bar__text {
  font-size: 13px;
}
/deep/.van-cell {
  margin-top: 10px;
}
/deep/ .van-cell__title span {
  font-weight: 550;
}
.sec {
  width: 100%;
  height: 35px;
  background: white;
  line-height: 35px;
  .sec-left {
    float: left;
    margin: 0 10px;
    img {
      width: 15px;
      height: 15px;
    }
    span {
      font-size: 12px;
      color: #aaaaaa;
      margin-left: 5px;
    }
  }
  .sec-right {
    float: right;
    margin: 0 10px;
    img {
      width: 20px;
      height: 20px;
      border: 1px dashed #ddd;
      position: relative;
      top: 7px;
    }
    span {
      font-size: 12px;
      margin-left: 5px;
    }
  }
}
.message {
  div {
    width: 50%;
    color: #aaaaaa;
    font-size: 13px;
    line-height: 24px;
    float: left;
  }
  span {
    color: black;
    font-size: 13px;
  }
  p {
    font-size: 13px;
    line-height: 24px;
  }
}
.message-bg {
  .message-bg1 {
    width: 100%;
    height: 5px;
    background: #007fc6;
  }
  border: 1px solid #f6f7f7;
  border-radius: 3px;
  overflow: hidden;
  p {
    width: 100%;
    background: #f8f5f4;
    height: 35px;
    line-height: 35px;
    color: black;
    font-size: 12px;
    font-weight: 550;
    text-align: center;
  }
  section {
    width: 100%;
    height: 35px;
    line-height: 35px;
    color: #343434;
    text-align: center;
  }
}
.jobdata {
  font-size: 13px;
  color: #000;
  margin-bottom: 15px;
  .jobdata-bt {
    margin-left: 25px;
    position: relative;
    .jobdata-flex {
      display: flex;
      justify-content: space-between;
      img {
        width: 13px;
        height: 13px;
        margin-right: 10px;
      }
      p {
        width: 70%;
      }
      div {
        width: 50%;
      }
    }
    div {
      width: 100%;
      height: 24px;
      span {
        float: left;
        color: #aaaaaa;
      }
      p {
        float: left;
      }
      .jobdata-i {
        margin: 3px 15px 0;
        padding: 0 3px;
        background: #733e2a;
        color: white;
        border-radius: 3px;
        font-size: 11px;
      }
    }
  }
  .jobdata-bt::before {
    content: '';
    position: absolute;
    display: block;
    left: -14px;
    top: -10px;
    width: 1px;
    height: 70px;
    background: #aeb5c2;
    overflow: hidden;
  }
}
.jobdata:last-of-type > .jobdata-bt::before {
  display: none;
}
.jobdata-top {
  color: #000;
  width: 100%;
  height: 24px;
  font-size: 13px;
  span {
    float: left;
  }
  .jobdata-crile img {
    width: 13px;
    height: 13px;
    margin: 0 5px;
  }
}
.workexp {
  section {
    padding: 10px 0;
    border-bottom: 1px #b6b1b1 dotted;
  }
  :last-child {
    border: none;
  }
  p {
    width: 100%;
    text-align: right;
    height: 24px;
    font-size: 13px;
    color: #000;
    span {
      float: left;
      margin-left: 5px;
    }
  }
  .work-bt {
    padding-left: 20px;
    .workexp-title {
      padding: 17px 12px 17px 7px;
      background: #f4f4f4;
      border-radius: 0 10px 10px;
      color: #000;
      font-size: 13px;
    }
  }
}
.edumessage {
  border: 1px solid #f6f7f7;
  .edumessage-bt {
    font-size: 12px;
    line-height: 34px;
    text-align: center;
  }
}
.message div[data-v-223468d8] {
  width: 60%;
}
.basic {
  div {
    width: 50%;
    color: #aaaaaa;
    font-size: 13px;
    line-height: 24px;
    float: left;
  }
  span {
    color: black;
    font-size: 13px;
  }
  p {
    font-size: 13px;
    line-height: 24px;
  }
  /deep/.van-popup {
    width: 60%;
    border-radius: 10px;
    .top {
      width: 100%;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 16px;
      color: #000;
      border-bottom: 1px solid rgb(158, 155, 155);
    }
    .button {
      display: flex;
      color: #000;
      height: 40px;
      width: 100%;
      p {
        width: 50%;
        font-size: 16px;
        text-align: center;
        line-height: 40px;
      }
    }
  }
}
.home {
  display: flex;
  .bold {
    font-size: 14px;
    margin: 0;
    color: black;
  }
  p {
    color: #2f78f6;
    margin-left: 10px;
    font-size: 13px;
    i {
      position: relative;
      top: 1px;
      margin: 0 5px;
    }
  }
}
.edit {
  color: #2f78f6;
  text-align: right;
  margin-right: 5%;
}
.blank {
  // margin-bottom: 20px;
  height: 10px;
}

.relation-box {
  width: 100%;
  height: 1px;
  margin: 0 auto;
  background: #ccc;
  margin: 10px 0px;
}
</style>